"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Button = _interopRequireDefault(require("../Button"));

var _Typography = require("../Typography");

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var _SectionHeader = require("./SectionHeader.style");

var _AddToCalendar = require("../AddToCalendar");

var SectionHeader = function SectionHeader(_ref) {
  var id = _ref.id,
      title = _ref.title,
      copy = _ref.copy,
      primaryCta = _ref.primaryCta,
      secondaryCta = _ref.secondaryCta,
      position = _ref.position,
      textSize = _ref.textSize,
      bgColor = _ref.bgColor;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      sectionHeader = _ref2.sectionHeader;

  var alignContent = {
    left: 'normal',
    center: 'center',
    right: 'flex-end'
  };
  var hasCta = !!primaryCta || !!secondaryCta;
  var ctaMargin = !title && !copy ? '0' : sectionHeader.buttonMarginTop;
  return /*#__PURE__*/_react.default.createElement(_SectionHeader.SectionContainer, {
    columnWidth: sectionHeader.columnWidth,
    bgColor: bgColor,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_SectionHeader.SectionWrapper, {
    alignItems: alignContent[position],
    bgColor: bgColor
  }, title && /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    size: "medium",
    textAlign: position
  }, title), copy && /*#__PURE__*/_react.default.createElement(_SectionHeader.SectionBody, {
    as: "div",
    mt: ['base', null, 'large'],
    size: textSize,
    position: position,
    hasTitle: !!title
  }, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: copy
  })), hasCta && /*#__PURE__*/_react.default.createElement(_SectionHeader.ButtonWrapper, {
    justifyContent: alignContent[position]
  }, primaryCta && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    mr: "base",
    mt: ctaMargin,
    startIcon: primaryCta.icon || ''
  }, primaryCta), primaryCta.label), secondaryCta && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: "secondary",
    mt: ctaMargin,
    startIcon: secondaryCta.icon || ''
  }, secondaryCta), secondaryCta.label))));
};

SectionHeader.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  copy: _propTypes.default.string,
  position: _propTypes.default.string,
  textSize: _propTypes.default.string,
  primaryCta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    icon: _propTypes.default.string,
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),
  secondaryCta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    icon: _propTypes.default.string,
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),
  bgColor: _propTypes.default.oneOf(['primary', 'secondary'])
};
SectionHeader.defaultProps = {
  id: '',
  title: '',
  copy: '',
  primaryCta: null,
  secondaryCta: null,
  position: 'left',
  textSize: 'large',
  bgColor: 'primary'
};
var _default = SectionHeader;
exports.default = _default;